<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-list nav dense height="100%" width="100%">
              <v-list-item-group>
                <v-list-item
                  v-for="item in headerLinks"
                  :key="item.title"
                  :to="item.to"
                >
                  <v-list-item-title v-if="item.show">
                    <v-icon class="pl-2">{{ item.icon }}</v-icon>
                    {{
                      $_t(`components.app.header.${item.title}`)
                    }}</v-list-item-title
                  >
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" md="3">
            <v-card dark color="blue darken-1">
              <v-card-title>
                <span>
                  <v-icon>mdi-account</v-icon>
                </span>
                <span class="pl-3"> {{ $_t("attribute.user_type") }}: </span>
                {{ $_t(`attribute.is_admin_${user.isAdmin}`) }}
              </v-card-title>
              <v-card-title class="pt-0">
                <span class="pl-3"> {{ $_t("attribute.mobileNumber") }}: </span>
                {{ enToFa(user.mobileNumber) }}
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="5">
            <v-card height="100%">
              <v-container fluid>
                <v-row>
                  <v-col cols="6" class="py-0">
                    <v-card-text class="font-weight-bold">
                      تعداد کل مدرک ها: {{ all.certs || 0 }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-card-text class="font-weight-bold pr-1">
                      تعداد کل کاربران: {{ all.users || 0 }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-card-text class="font-weight-bold">
                      مبالغ پرداخت شده: {{ all.totalPays || 0 }} تومان
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-card height="100%">
          <v-container fluid>
            <router-view></router-view>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import {enToFa} from "@/tools/Utils";

export default {
  name: "Admin.layout",
  computed: {
    ...mapGetters({
      user: "authentication/user",
      itemsLength: "pagination/get_items_length",
      all: "admin/get_all",
    }),
    headerLinks() {
      return [
        {
          icon: "mdi-view-dashboard",
          title: "dashboard",
          to: { name: "admin.main" },
          show: !!this.user,
        },
        {
          icon: "mdi-account",
          title: "users",
          to: { name: "admin.users" },
          show: !!this.user,
        },
      ];
    },
  },
  methods:{
    enToFa,
  },
  async mounted() {
    await this.$actions.getAll();
  },
};
</script>

<style scoped></style>
